import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import InfoModal from '../../../../../features/components/Modals/InfoModal'
import ProgressButton from '../../../../../components/Form/ProgressButton'

import { ReactComponent as WarningIcon } from '../../../../../assets/icons/warning-icon.svg'

import { updateMemberStatus } from '../../../../../modules/actions/team'
import { updatedMemberSelector } from '../../../../../modules/selectors/team'

import { MEMBER_CHANGE_STATUS } from '../../../../../constants/forms'

const DeactivateUserModal = ({ selfAccountName, memberId, isModalOpened, closeModalHandler }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const {
    isLoading: isUpdatedMemberLoading,
    wasUpdated: memberWasUpdated,
    error: updateMemberError,
    updatingType
  } = useSelector(updatedMemberSelector)

  const isUpdateMemberStatusLoading = updatingType === MEMBER_CHANGE_STATUS && isUpdatedMemberLoading
  const memberStatusWasUpdated = updatingType === MEMBER_CHANGE_STATUS && memberWasUpdated
  const updateMemberStatusError = updatingType === MEMBER_CHANGE_STATUS && updateMemberError

  const onModalButtonClick = useCallback(() => {
    dispatch(updateMemberStatus(memberId, 'active'))
  }, [dispatch, memberId])

  return (
    <InfoModal
      Icon={WarningIcon}
      isOpen={isModalOpened}
      onClose={closeModalHandler}
      modalTitle="Are you sure?"
      Buttons={
        <ProgressButton
          isFormLoading={isUpdateMemberStatusLoading}
          formError={updateMemberStatusError}
          successSubmit={memberStatusWasUpdated}
          onClick={onModalButtonClick}
        >
          {t('Deactivate')}
        </ProgressButton>
      }
    >
      <p>{t(`Deactivating this user will mean they will no longer have access to the ${selfAccountName} account.`)}</p>
      <p>{t('You can reactivate them later if needed.')}</p>
    </InfoModal>
  )
}

DeactivateUserModal.propTypes = {
  selfAccountName: PropTypes.string.isRequired,
  memberId: PropTypes.number,
  isModalOpened: PropTypes.bool.isRequired,
  closeModalHandler: PropTypes.func.isRequired
}

export default DeactivateUserModal
